import { ComponentRef } from "@angular/core";

export class DomNode {
    rteId: string;
    rteNode: Element;
    viewNode: Element;
    // Angular components created to render the node after editing.
    viewComponents = [];
    innerHtmlWasRendered: boolean;

    private eventListeners = [];

    addListener(listener) {
        this.eventListeners.push(listener);
    }

    dispose() {
        for (let i = 0; i < this.eventListeners.length; i++) {
            this.eventListeners[i](); // Removes a listener
        }
        this.eventListeners = [];
    }
}